// extracted by mini-css-extract-plugin
module.exports = {"Unsubscribe":"_1Qs9BMyx","title":"_9_57IOc","button":"NuxvRntE","content":"b7M_cUud","divider":"Jtlbc8zx","warningMessageContainer":"_2-HomUlF","warningIcon":"_1QUkVptD"};